import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { BeneficiaryService } from '../services/beneficiary.service';
import { CommonService } from '../services/common.service';
import {MatCardModule} from '@angular/material/card'
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { TransactionService } from '../services/transaction.service';
import { Placeholder } from '@angular/compiler/src/i18n/i18n_ast';
import { threadId } from 'worker_threads';

@Component({
  selector: 'app-beneficiary',
  templateUrl: './beneficiary.component.html',
  styleUrls: ['./beneficiary.component.css']
})
export class BeneficiaryComponent implements OnInit {

  beneficiaries : []
  beneficiariesToBeShown : []
  beneficiaryFormBank : FormGroup
  beneficiaryFormUpi : FormGroup
  beneficiaryFormMobile : FormGroup
  bankKeys
  upiKeys
  mobileKeys
  isVerifiedIfsc = false

  banks
  mobileProviders
  idtypes

  //bank || upi || mobile
  newBeneficiaryType = 'bank'

  test

  constructor(public beneficiaryService : BeneficiaryService, private common : CommonService, private fb : FormBuilder, private transactionService : TransactionService) { }

  ngOnInit(): void {
    this.beneficiaryFormBank = this.fb.group({
      name: ["", [Validators.required]],
      IFSC: ["", [Validators.required, Validators.maxLength(11), Validators.minLength(11)]],
      acNumber: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      mobNumber: ["", [Validators.required]]
    })
    this.beneficiaryFormUpi = this.fb.group({
      name: ["", [Validators.required]],
      upi: ["", [Validators.required]],
      email: ["", [Validators.email]],
      mobNumber: [""]
    })
    this.beneficiaryFormMobile = this.fb.group({
      name: ["", [Validators.required]],
      IFSC: ["", [Validators.required, Validators.maxLength(11), Validators.minLength(11)]],
      acNumber: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      mobNumber: ["", [Validators.required]]
    })

    setTimeout(() => {
      this.getAllBeneficiaries()
      this.getAllDestinations()
    }, 0);
  }

  setupBankForm(bank){
    this.common.showLoader()
    this.bankKeys = Object.keys(bank)
    this.beneficiaryFormBank = this.fb.group({})
    let formObj = {}
    for(let field in bank){
      formObj[field] = ["", Validators.compose(this.addValidations(bank[field]))]
    }
    this.beneficiaryFormBank = this.fb.group(formObj)
    this.common.hideLoader()
  }

  setupUpiForm(upi){
    this.common.showLoader()
    this.upiKeys = Object.keys(upi)
    this.beneficiaryFormUpi = this.fb.group({})
    let formObj = {}
    for(let field in upi){
      formObj[field] = ["", Validators.compose(this.addValidations(upi[field]))]
    }
    this.beneficiaryFormUpi = this.fb.group(formObj)
    this.common.hideLoader()
  }

  setupMobileForm(mobile){
    this.common.showLoader()
    this.mobileKeys = Object.keys(mobile)
    this.beneficiaryFormMobile = this.fb.group({})
    let formObj = {}
    for(let field in mobile){
      formObj[field] = ["", Validators.compose(this.addValidations(mobile[field]))]
    }
    this.beneficiaryFormMobile = this.fb.group(formObj)
    this.common.hideLoader()
  }

  getAllBeneficiaries(){
    this.common.showLoader()
    this.beneficiaryService.getAllBeneficiaries().subscribe((res:any) => {
      this.common.hideLoader()
      this.beneficiaries = res
      if(this.beneficiaryService.selectedDestination){
        this.setSpecificBeneficiaries(this.beneficiaryService.selectedDestination.name)
      }
    }, (err : any) => {
      this.common.hideLoader()
      console.log(err)
    })
  }

  getAllDestinations(){
    this.common.showLoader()
    this.common.getAllDestinations().subscribe((res:any)=>{
      this.common.hideLoader()
      this.beneficiaryService.destinations = res
      // this.selectDestination(res[0])
      // this.getExchangeRate(this.transactionService.source, this.beneficiaryService.selectedDestination.name)
    }, (err:any)=>{
      this.common.hideLoader()
      console.log(err)
    })
  }

  addBeneficiary(form){
    let data = form.value
    data = {...data, destination_currency: this.beneficiaryService.selectedDestination.id}
    this.common.showLoader()
    this.beneficiaryService.addNewBeneficiary(data).subscribe((res:any)=>{
      this.common.hideLoader()
      this.getAllBeneficiaries()
      this.beneficiaryFormBank.reset()
      this.beneficiaryFormUpi.reset()
      this.beneficiaryFormMobile.reset()
      
      document.getElementById("inrAddBeneficiary").classList.remove('show')
    }, (err:any)=>{
      console.log(err)
      this.common.hideLoader()
    })
  }

  verifyIfsc(ifsc){
    this.common.showLoader()
    this.beneficiaryService.verifyIfsc(ifsc).subscribe((res:any) => {
      console.log(res)
    },(err:any) => {
      this.common.hideLoader()
      console.log(err)
    })
  }

  selectBeneficiary(beneficiary){
    if(this.transactionService.isConnectedWallet){
      this.transactionService.sourceAmount = 0
      this.transactionService.convertedAmount = 0
      this.beneficiaryService.selectedBeneficiary = beneficiary
      // this.beneficiaryService.selectedDestination = beneficiary.destination_currency
      this.transactionService.upper_limit = beneficiary.destination_currency.limits.max
      this.transactionService.lower_limit = beneficiary.destination_currency.limits.min
    this.getExchangeRate(this.transactionService.source, this.beneficiaryService.selectedDestination.name)

      if(this.beneficiaryService.selectedDestination.name!='INR' && this.beneficiaryService.selectedDestination.metadata.bank){
        this.getBanks(this.beneficiaryService.selectedDestination.country)
      }
      if(this.beneficiaryService.selectedDestination.name!='USD' && this.beneficiaryService.selectedDestination.metadata.mobile){
        this.getProviders(this.beneficiaryService.selectedDestination.country)
      }
  
      if(this.beneficiaryService.selectedDestination.metadata.bank){
        this.setupBankForm(this.beneficiaryService.selectedDestination.metadata.bank)
      }
      if(this.beneficiaryService.selectedDestination.metadata.upi){
        this.setupUpiForm(this.beneficiaryService.selectedDestination.metadata.upi)
      }
      if(this.beneficiaryService.selectedDestination.metadata.mobile){
        this.setupMobileForm(this.beneficiaryService.selectedDestination.metadata.mobile)
      }
      // console.log(this.beneficiaryService.sele.ctedthisbeneficiaryService.selectedDestination)
    }
      
    else  
      alert("connect wallet first!")
  }

  selectBeneficiaryType(type){
    this.newBeneficiaryType = type
    if(type=='bank'){
      this.beneficiaryFormUpi.reset()
      this.beneficiaryFormMobile.reset()
      // this.setupBankForm(this.beneficiaryService.selectedDestination.metadata.bank)
    }
    else if(type=='upi'){
      this.beneficiaryFormBank.reset()
      this.beneficiaryFormMobile.reset()
      // this.setupUpiForm(this.beneficiaryService.selectedDestination.metadata.upi)
    }
    else if(type=='mobile'){
      this.beneficiaryFormBank.reset()
      this.beneficiaryFormUpi.reset()
      // this.setupMobileForm(this.beneficiaryService.selectedDestination.metadata.mobile)

    }
  }

  selectDestination(destination){
    this.setSpecificBeneficiaries(destination.name)
    
    this.beneficiaryService.selectedBeneficiary = ''
    this.transactionService.sourceAmount = 0
    this.transactionService.convertedAmount = 0
    if(destination.name=='UGX' || destination.name=='XOF-Togo' || destination.name=='XOF-Mali'){
      this.selectBeneficiaryType('mobile')
    }
    else{
      this.selectBeneficiaryType('bank')
    }
    this.banks = []
    this.mobileProviders = []
    this.beneficiaryService.selectedDestination = destination
    this.getFees()
    this.getExchangeRate(this.transactionService.source, this.beneficiaryService.selectedDestination.name)
    
    this.transactionService.convertedAmount = 0
    this.transactionService.sourceAmount = 0
    this.beneficiaryFormBank.reset()
    this.beneficiaryFormUpi.reset()
    this.beneficiaryFormMobile.reset()

    if(destination.name!='IND' && destination.metadata.bank){
      this.getBanks(destination.country)
      this.getIdTypes(destination.name)
    }
    if(destination.metadata.mobile){
      this.getProviders(destination.country)
      this.getIdTypes(destination.name)
    }

    if(destination.metadata.bank){
      this.setupBankForm(destination.metadata.bank)
    }
    if(destination.metadata.upi){
      this.setupUpiForm(destination.metadata.upi)
      this.getIdTypes(destination.name)
    }
    if(destination.metadata.mobile){
      this.setupMobileForm(destination.metadata.mobile)
    }

    
  }

  getExchangeRate(source, destination){
    
    if(source && destination){
      this.common.showLoader()
      this.common.getExchangeRate(source, destination).subscribe((res:any)=>{
        this.common.hideLoader()
        this.transactionService.conversionRate = res[0].rate
      }, (err:any)=>{
        this.common.hideLoader()
        console.log(err)
      })
    }
    
  }

  getBanks(country){
    this.common.showLoader()
    this.beneficiaryService.getAllBanks(country).subscribe((res:any)=>{
      this.common.hideLoader()
      this.banks = res
    }, (err)=>{
      this.common.hideLoader()
      console.log(err)
    })
  }

  getProviders(country){
    this.common.showLoader()
    this.beneficiaryService.getAllProviders(country).subscribe((res:any)=>{
      this.common.hideLoader()
      this.mobileProviders = res
    }, (err)=>{
      this.common.hideLoader()
      console.log(err)
    })
  }

  getIdTypes(destination_currency){
    this.common.showLoader()
    this.beneficiaryService.getIdTypes(destination_currency).subscribe((res:any)=>{
      this.common.hideLoader()
      this.idtypes = res
    }, (err)=>{
      this.common.hideLoader()
      console.log(err)
    })
  }

  addValidations(field){
    let array = []
    field.validations.required ? array.push(Validators.required) : ''
    field.validations.minLength ? array.push(Validators.minLength(+field.validations.minLength)) : ''
    field.validations.maxLength ? array.push(Validators.maxLength(+field.validations.maxLength)) : ''
    field.validations.email ? array.push(Validators.email) : ''
    field.validations.pattern ? array.push(Validators.pattern(field.validations.pattern)) : ''

    return array
  }

  setSpecificBeneficiaries(currency){
    this.beneficiariesToBeShown = []
    this.beneficiaries?.forEach((beneficiary:any)=>{
      if(beneficiary.destination_currency?.name==currency){
        //@ts-ignore
        this.beneficiariesToBeShown.push(beneficiary)
      }
    })
  }

  deleteBeneficiary(id){
    let confirmation = confirm("Sure you want to delete the beneficiary?")
    if(confirmation){
      this.common.showLoader()
      this.beneficiaryService.deleteBeneficiary(id).subscribe((res:any)=>{
        this.common.hideLoader()
        this.getAllBeneficiaries()
      }, (err)=>{
        console.log(err)
        this.common.hideLoader()
      })
    }
    
  }

  getFees(){
    console.log(this.beneficiaryService.selectedDestination?.name)
    this.common.getFees(this.transactionService.source, this.beneficiaryService.selectedDestination?.name).subscribe((res) => {
      this.transactionService.fees = res[0]?.amount
    }, (err) => {
      console.log(err)
    })
  }
}



